const pendingRequests = new Map();

function generateId() {
    return new Date().getTime();
}
export const setupAxiosInterceptors = (axiosInstance) => {
    axiosInstance.interceptors.request.use(requestHandler, requestErrorHandler);
    axiosInstance.interceptors.response.use(responseHandler, responseErrorHandler);
};

function requestHandler(config) {
    // extract isCancellable from request params to prevent sending it to backend
    const { isCancellable, ...params } = config.params || {};
    config.params = params;
    if (isCancellable) {
        const requestKey = generateRequestKey(config);
        if (pendingRequests.has(requestKey)) {
            const toCancel = pendingRequests.get(requestKey);
            toCancel.abort();
        }
        const controller = new AbortController();
        config.signal = controller.signal;
        const id = generateId();
        controller.id = id;
        config.id = id;
        pendingRequests.set(requestKey, controller);
    }
    return config;
}

function requestErrorHandler(error) {
    return Promise.reject(error);
}

function responseHandler(response) {
    const requestKey = generateRequestKey(response.config);
    const pendingRequest = pendingRequests.get(requestKey);
    if (pendingRequest && pendingRequest.id === response.config.id) {
        pendingRequests.delete(requestKey);
    }
    return response;
}

function responseErrorHandler(error) {
    const requestKey = error.config && generateRequestKey(error.config);
    const pendingRequest = pendingRequests.get(requestKey);
    if (requestKey && pendingRequest && pendingRequest.id === error.config.id) {
        pendingRequests.delete(requestKey);
    }

    return Promise.reject(error);
}

const generateRequestKey = (config) => {
    const { url, method } = config;
    return [url, method].join('&');
};
